<div class="h-full w-full p-3 overflow-y-scroll">
  <app-breadcrumb [items]="[{ label: 'Organizations', route: '/organizations' },{ label: 'Surveys' }]"/>

  @if (canEdit() && organizationStore.selectedOrganizationId()) {
  <div class="mb-3 flex justify-end">
    <button type="button" (click)="requestCreate()" class="flex items-center gap-1.5 rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700">
      <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>
      Create Survey
    </button>
  </div>
  }

  <div class="rounded-sm border border-stroke bg-white">
    <table class="w-full table-auto">
      <thead>
        <tr class="bg-gray-2 text-left dark:bg-meta-4">
          <th class="py-4 px-4 font-medium text-black dark:text-white">
            Survey Name
          </th>

          <th class="py-4 px-4 font-medium text-black dark:text-white">
            Survey ID
          </th>

          <th class="py-4 px-4 font-medium text-black dark:text-white">
            Last Update
          </th>

          <th class="py-4 px-4 font-medium text-black dark:text-white">
            Action
          </th>
        </tr>
      </thead>

      <tbody>
        @for (survey of organizationStore.selectedOrganizationSurveys(); track survey.id) {
          <tr class="border-b border-[#eee] dark:border-strokedark">
            <td class="py-5 px-4">
              <p class="font-medium text-black dark:text-white">
                {{ survey.name }}
              </p>
            </td>

            <td class="py-5 px-4">
              <div class="flex items-center gap-2">
                <button type="button" (click)="copyToClipboard(survey.id)"
                  class="group relative font-mono text-sm text-gray-600 hover:text-gray-800 dark:hover:text-gray-200 transition-colors" [title]="survey.id">
                  @if (copiedText() === survey.id) {
                    <span class="flex items-center gap-1.5 text-green-500">
                      <svg class="h-3.5 w-3.5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                      Copied!
                    </span>
                  } @else {
                    <svg class="absolute -left-4 top-1/2 -translate-y-1/2 h-3.5 w-3.5 opacity-0 group-hover:opacity-100 transition-opacity" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                    </svg>
                    <span class="inline-block truncate">{{ survey.id }}</span>
                  }
                </button>
              </div>
            </td>

            <td class="py-5 px-4">
              <p class="text-sm text-gray-700 dark:text-white">
                {{ survey.lastUpdatedOn }}
              </p>
            </td>

            <td class="py-5 px-4">
              <nav class="flex items-center gap-1">
                <a [routerLink]="['/surveys', survey?.id, 'builder']" (click)="organizationStore.setSurveyById(survey.id)" class="rounded-md bg-gray-200 px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-300 hover:text-gray-900 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700 dark:hover:text-gray-200">
                  Builder
                </a>
                <a [routerLink]="['/surveys', survey?.id, 'cmd']" (click)="organizationStore.setSurveyById(survey.id)" class="rounded-md bg-gray-200 px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-300 hover:text-gray-900 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700 dark:hover:text-gray-200">
                  CMD
                </a>
                <a [routerLink]="['/surveys', survey?.id, 'translations']" (click)="organizationStore.setSurveyById(survey.id)" class="rounded-md bg-gray-200 px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-300 hover:text-gray-900 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700 dark:hover:text-gray-200">
                  Translations
                </a>
                <a [routerLink]="['/surveys', survey?.id, 'fieldworks']" (click)="organizationStore.setSurveyById(survey.id)" class="rounded-md bg-gray-200 px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-300 hover:text-gray-900 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700 dark:hover:text-gray-200">
                  Fieldworks
                </a>
                <a [routerLink]="['/surveys', survey?.id, 'businessrules']" (click)="organizationStore.setSurveyById(survey.id)" class="rounded-md bg-gray-200 px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-300 hover:text-gray-900 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700 dark:hover:text-gray-200">
                  Business Rules
                </a>
                <a [routerLink]="['/surveys', survey?.id, 'alert']" (click)="organizationStore.setSurveyById(survey.id)" class="rounded-md bg-gray-200 px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-300 hover:text-gray-900 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700 dark:hover:text-gray-200">
                  Alerts
                </a>
                @if (canEdit()) {
                <button type="button" (click)="requestClone(survey)" class="rounded-md bg-blue-100 px-3 py-1.5 text-sm font-medium text-blue-700 transition-colors hover:bg-blue-200 dark:bg-blue-500/10 dark:text-blue-400 dark:hover:bg-blue-500/20">
                  Clone
                </button>
                }
              </nav>
            </td>
          </tr>
        } @empty {
          @if (organizationStore.selectedOrganizationId()){
          <tr>
            <td colspan="3" class="py-8 text-center text-bodydark2">
              This organization has no surveys.
            </td>
          </tr>
          }
          @else {
          <tr>
            <td colspan="3" class="py-8 text-center text-bodydark2">
              No organization selected. Select an organization first.
            </td>
          </tr>
          }
        }
      </tbody>
    </table>
  </div>
</div>

@if (dialogMode()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40" (click)="cancelDialog()">
  <div class="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl dark:bg-gray-900" (click)="$event.stopPropagation()">
    @if (dialogMode() === 'clone') {
    <h3 class="text-base font-semibold text-gray-800 dark:text-white">Clone survey</h3>
    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
      Create a new survey from <span class="font-medium text-gray-700 dark:text-gray-300">{{ cloneSource()?.name }}</span>.
    </p>
    } @else {
    <h3 class="text-base font-semibold text-gray-800 dark:text-white">Create survey</h3>
    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
      Create a new, empty survey in this organization.
    </p>
    }

    <div class="mt-4 flex flex-col gap-3">
      <div>
        <label class="mb-1 block text-xs text-gray-500 dark:text-gray-400">New Survey ID</label>
        <input type="text" [(ngModel)]="newSurveyId" [disabled]="saving()"
          class="h-9 w-full rounded-lg border border-gray-300 bg-transparent px-2 text-sm text-gray-800 shadow-sm focus:outline-none dark:border-gray-700 dark:text-white"
          [class.border-error-500]="!!surveyIdError"/>
        @if (surveyIdError) {
          <p class="mt-1 text-xs text-error-600">{{ surveyIdError }}</p>
        } @else {
          <p class="mt-1 text-xs text-gray-400">Letters, numbers, and - only. No spaces.</p>
        }
      </div>
      <div>
        <label class="mb-1 block text-xs text-gray-500 dark:text-gray-400">New Survey Name</label>
        <input type="text" [(ngModel)]="newSurveyName" [disabled]="saving()"
          class="h-9 w-full rounded-lg border border-gray-300 bg-transparent px-2 text-sm text-gray-800 shadow-sm focus:outline-none dark:border-gray-700 dark:text-white"/>
      </div>
      <div>
        <label class="mb-1 block text-xs text-gray-500 dark:text-gray-400">Type</label>
        <select [(ngModel)]="newSurveyType" [disabled]="saving()"
          class="h-9 w-full rounded-lg border border-gray-300 bg-white px-2 text-sm text-gray-800 shadow-sm focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-white">
          <option value="" disabled>Select type</option>
          @for (type of surveyTypes; track type) {
            <option [value]="type">{{ type }}</option>
          }
        </select>
      </div>
    </div>

    @if (dialogError()) {
    <p class="mt-3 rounded-lg bg-error-50 px-3 py-2 text-sm text-error-700 dark:bg-error-500/10 dark:text-error-400">{{ dialogError() }}</p>
    }

    <div class="mt-5 flex justify-end gap-3">
      <button type="button" (click)="cancelDialog()" [disabled]="saving()" class="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
        Cancel
      </button>
      <button type="button" (click)="confirmDialog()" [disabled]="saving() || !canSubmitDialog" class="flex items-center gap-2 rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700 disabled:opacity-50 disabled:cursor-not-allowed">
        @if (saving()) {
          <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>
          {{ dialogMode() === 'clone' ? 'Cloning...' : 'Creating...' }}
        } @else {
          {{ dialogMode() === 'clone' ? 'Clone' : 'Create' }}
        }
      </button>
    </div>
  </div>
</div>
}